import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    Box,
    Card,
    CardContent,
    TextField,
    Button,
    Typography,
    Alert,
    Container,
    CircularProgress,
} from '@mui/material';
import { Email, ArrowBack } from '@mui/icons-material';
import { authAPI } from '../../services/api';
import './ForgotPassword.css';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess(false);
        setLoading(true);

        try {
            const response = await authAPI.forgotPassword(email);
            setSuccess(true);
            setEmail('');
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to send reset email. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box className="forgot-password-container">
            <Container maxWidth="sm">
                <Card elevation={3} sx={{ mt: 8 }}>
                    <CardContent sx={{ p: 4 }}>
                        <Box sx={{ textAlign: 'center', mb: 3 }}>
                            <Email sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
                            <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
                                Forgot Password?
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                No worries! Enter your email address and we'll send you a link to reset your password.
                            </Typography>
                        </Box>

                        {error && (
                            <Alert severity="error" sx={{ mb: 2 }}>
                                {error}
                            </Alert>
                        )}

                        {success && (
                            <Alert severity="success" sx={{ mb: 2 }}>
                                Password reset link has been sent to your email. Please check your inbox and spam folder.
                            </Alert>
                        )}

                        <form onSubmit={handleSubmit}>
                            <TextField
                                fullWidth
                                label="Email Address"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                disabled={loading || success}
                                sx={{ mb: 3 }}
                                autoFocus
                            />

                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth
                                size="large"
                                disabled={loading || success}
                                sx={{ mb: 2, py: 1.5 }}
                            >
                                {loading ? <CircularProgress size={24} /> : 'Send Reset Link'}
                            </Button>

                            <Button
                                component={Link}
                                to="/login"
                                variant="text"
                                fullWidth
                                startIcon={<ArrowBack />}
                                sx={{ textTransform: 'none' }}
                            >
                                Back to Login
                            </Button>
                        </form>
                    </CardContent>
                </Card>
            </Container>
        </Box>
    );
};

export default ForgotPassword;
